import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback, useState } from 'react';
import { ALL_CONFIG_FLAG_PROPERTIES, isConfigFlagEnabled, overrideConfigFlag } from '../../../config';
import { YELLOW_COLOR } from '../../../styles/colors';
import { getOnOffBooleanLabel } from '../../../utils/utils';
import { FormControlContainer } from '../../formControlContainer';
import { IconWithLabelDisplay } from '../../iconWithLabelDisplay';
/**
 * "Experimental" settings are config flags that are set to be overridable via the Settings modal, and therefore are
 * exposed to the user as something they can test out.
 */
export const ExperimentalSettingItem = ({ configFlag }) => {
    const [isEnabled, setIsEnabled] = useState(isConfigFlagEnabled(configFlag));
    const onClick = useCallback(() => {
        const newIsEnabled = !isEnabled;
        overrideConfigFlag(configFlag, newIsEnabled);
        setIsEnabled(newIsEnabled);
    }, [configFlag, isEnabled]);
    const configFlagName = ALL_CONFIG_FLAG_PROPERTIES[configFlag].name || configFlag;
    const stateLabel = getOnOffBooleanLabel(isEnabled);
    const ariaLabel = `${configFlagName}: ${stateLabel}`;
    return (_jsx(FormControlContainer, { "aria-label": configFlagName, children: _jsxs("div", { css: css `
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 5px;
        `, children: [_jsx("div", { css: css `
            flex-grow: 1;
          `, children: _jsxs(Typography, { component: 'div', children: [_jsx("span", { "aria-hidden": true, children: configFlagName }), _jsx("span", { css: css `
                font-size: 85%;
              `, children: _jsx(IconWithLabelDisplay, { color: YELLOW_COLOR, icon: _jsx(WarningRoundedIcon, {}), label: 'Experimental - Setting resets every session' }) })] }) }), _jsx("div", { children: _jsx(Button, { variant: 'contained', onClick: onClick, "aria-label": ariaLabel, children: stateLabel }) })] }) }));
};
